module.exports = __webpack_public_path__ + "assets/img/37_1634_big.2c25acd3.jpg";